'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstMenu = function (_VstComponent) {
  _inherits(VstMenu, _VstComponent);

  function VstMenu() {
    _classCallCheck(this, VstMenu);

    var _this = _possibleConstructorReturn(this, (VstMenu.__proto__ || Object.getPrototypeOf(VstMenu)).call(this));

    _this._updatePosition = _this._updatePosition.bind(_this);
    _this._clickMenuMask = _this._clickMenuMask.bind(_this);
    _this.state = {
      arrowRight: 15,
      menuRight: 0,
      top: 44
    };
    return _this;
  }

  _createClass(VstMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible) {
        this._updatePosition();
      }
    }
  }, {
    key: '_updatePosition',
    value: function _updatePosition() {
      var callee = this.refs.vstMenu.parentElement.parentElement;
      var menuRight = document.body.offsetWidth - callee.offsetWidth - callee.offsetLeft;
      var offsetRight = menuRight < 6 ? 6 - menuRight : 0;
      this.setState({
        arrowRight: callee.offsetWidth / 2 - 4 - offsetRight,
        menuRight: menuRight + offsetRight,
        arrowTop: callee.offsetTop + callee.offsetHeight + 8
      });
    }
  }, {
    key: '_clickMenuMask',
    value: function _clickMenuMask() {
      if (this.props.closeMenu) {
        this.props.closeMenu();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'div',
          { style: { right: this.state.menuRight, top: this.state.arrowTop },
            ref: 'vstMenu',
            className: (0, _classnames2.default)(this.props.className, 'vst-menu', { visible: this.props.visible })
          },
          _react2.default.createElement('div', { ref: 'pointer',
            className: 'pointer up',
            style: { right: this.state.arrowRight }
          }),
          this.props.children
        ),
        _react2.default.createElement('div', { className: (0, _classnames2.default)('vst-menu-mask', { visible: this.props.visible }), onClick: this._clickMenuMask })
      );
    }
  }]);

  return VstMenu;
}(_VstComponent3.default);

exports.default = VstMenu;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstMenu.js
 **/